import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { clearToken } from "@/lib/auth";
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

export const AdminLayout = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    clearToken();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#f1f5f9] text-vg-ink" data-testid="admin-layout">
      <div className="flex min-h-screen">
        <aside className="hidden lg:flex lg:w-64 lg:shrink-0 lg:sticky lg:top-0 lg:h-screen">
          <AdminSidebar onLogout={handleLogout} className="w-full" />
        </aside>

        <div className="flex flex-1 flex-col min-w-0">
          <header className="lg:hidden sticky top-0 z-40 flex items-center justify-between gap-3 border-b border-black/10 bg-white px-4 h-14">
            <span className="text-sm font-semibold tracking-tight">VG Mart Admin</span>
            <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
              <SheetTrigger asChild>
                <button
                  type="button"
                  className="inline-flex items-center justify-center h-9 w-9 border border-black/10 text-vg-ink hover:bg-black/5"
                  aria-label="Open admin menu"
                  data-testid="admin-mobile-menu-button"
                >
                  <Menu size={18} />
                </button>
              </SheetTrigger>
              <SheetContent side="left" className="w-72 p-0 border-black/10">
                <SheetTitle className="sr-only">Admin navigation</SheetTitle>
                <AdminSidebar
                  onNavigate={() => setMenuOpen(false)}
                  onLogout={handleLogout}
                  className="w-full"
                />
              </SheetContent>
            </Sheet>
          </header>

          <main className="flex-1 p-4 sm:p-6 lg:p-8">
            <div className="max-w-6xl mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
